export const registerServiceWorker = () => {
  // Registering in dev means webpack-dev-server's unhashed chunk filenames
  // (e.g. vendors-....chunk.js) get served from the SW's cache-first fetch
  // handler forever, regardless of server restarts or browser refreshes —
  // "Loading chunk ... failed" / "Unexpected token '<'" errors that only a
  // manual unregister + cache clear in DevTools fixes. Only register in
  // production, where webpack content-hashes chunk filenames so a new
  // deploy naturally busts the old cache entries.
  if (!('serviceWorker' in navigator)) return
  if (process.env.NODE_ENV !== 'production') {
    // Remove service workers que ficaram instalados de builds anteriores
    // (servem bundle.js antigo do cache e quebram o carregamento dos chunks).
    navigator.serviceWorker.getRegistrations()
      .then(registrations => Promise.all(registrations.map(r => r.unregister())))
      .then(() => (window.caches ? caches.keys() : []))
      .then(keys => Promise.all(keys.map(key => caches.delete(key))))
      .catch(() => {})
    return
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(error => {
      console.error('Não foi possível registrar o PWA:', error)
    })
  })
}
